"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));
/** Animated icons to show when applications are working */


var LoadingIndicator = function LoadingIndicator(props) {
  var _classnames;

  var color = props.color,
      htmlId = props.htmlId,
      className = props.className,
      floatToSide = props.floatToSide,
      size = props.size;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: htmlId,
    className: (0, _classnames2["default"])("cx-loadingIndicator", "cx-loadingIndicator--".concat(color), className, (_classnames = {}, (0, _defineProperty2["default"])(_classnames, "cx-loadingIndicator--".concat(floatToSide), floatToSide), (0, _defineProperty2["default"])(_classnames, "cx-loadingIndicator--".concat(size), size), _classnames))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cx-loadingIndicator__dots"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cx-loadingIndicator__dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cx-loadingIndicator__dot"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cx-loadingIndicator__dot"
  })));
};

LoadingIndicator.defaultProps = {
  className: "",
  color: "gray"
};
var _default = LoadingIndicator;
exports["default"] = _default;